<template>
  <v-rectangle
    :bounds="square.points"
    :fillColor="fillSquareWithColor(square.color, square.strength)"
    :weight="0"
    :fillOpacity="0.5"
  ></v-rectangle>
</template>

<script>
import * as Vue2Leaflet from "vue2-leaflet";

export default {
  name: "MapCompetitionlayer",
  components: {
    vRectangle: Vue2Leaflet.LRectangle
  },
  props: {
    square: {
      type: Object,
      required: true
    }
  },
  methods: {
    fillSquareWithColor(color, strength) {
      if (color == "orange") return "#FF9800";
      if (color == "pink") {
        if (strength > 0.0 && strength <= 0.33) return "#EC407A"; // lighten-1
        if (strength > 0.33 && strength <= 0.66) return "#E91E63"; // default
        if (strength > 0.66 && strength <= 1) return "#C2185B"; // darken-2
      }
      if (color == "purple") {
        if (strength > 0.0 && strength <= 0.33) return "#AB47BC"; // lighten-1
        if (strength > 0.33 && strength <= 0.66) return "#9C27B0"; // default
        if (strength > 0.66 && strength <= 1) return "#7B1FA2"; // darken-2
      }
      if (color == "indigo") {
        if (strength > 0.0 && strength <= 0.33) return "#5C6BC0"; // lighten-1
        if (strength > 0.33 && strength <= 0.66) return "#3F51B5"; // default
        if (strength > 0.66 && strength <= 1) return "#303F9F"; // darken-2
      }
      if (color == "cyan") {
        if (strength > 0.0 && strength <= 0.33) return "#26C6DA"; // lighten-1
        if (strength > 0.33 && strength <= 0.66) return "#00BCD4"; // default
        if (strength > 0.66 && strength <= 1) return "#0097A7"; // darken-2
      }
      if (color == "teal") {
        if (strength > 0.0 && strength <= 0.33) return "#26A69A"; // lighten-1
        if (strength > 0.33 && strength <= 0.66) return "#009688"; // default
        if (strength > 0.66 && strength <= 1) return "#00796B"; // darken-2
      }
    }
  }
};
</script>
